
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import PropertyCard from "../PropertyCard";

const TopPropertiesTab = () => {
  const properties = [
    { 
      title: "Seaside Luxury Villa", 
      location: "Colombo 03", 
      views: 245, 
      inquiries: 12, 
      price: "$1.2M",
      featured: true,
      image: "/colombo-03.png"
    },
    { 
      title: "Downtown Apartment", 
      location: "Colombo 07", 
      views: 189, 
      inquiries: 8, 
      price: "$850K",
      featured: false,
      image: "/colombo-07.png"
    },
    { 
      title: "Mountain Retreat", 
      location: "Rajagiriya", 
      views: 156, 
      inquiries: 5, 
      price: "$1.5M",
      featured: false,
      image: "/rajagiriya.png"
    }
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {properties.map((property, i) => (
          <PropertyCard 
            key={i}
            title={property.title}
            location={property.location}
            views={property.views}
            inquiries={property.inquiries}
            price={property.price}
            featured={property.featured}
            image={property.image}
          />
        ))}
      </div>
      <div className="flex justify-center">
        <Button variant="outline" asChild>
          <Link to="/dashboard/listings">
            View All Properties
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default TopPropertiesTab;
